import { render, staticRenderFns } from "./my-profile.vue?vue&type=template&id=37a3f205&scoped=true"
import script from "./my-profile.vue?vue&type=script&lang=js"
export * from "./my-profile.vue?vue&type=script&lang=js"
import style0 from "./my-profile.vue?vue&type=style&index=0&id=37a3f205&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a3f205",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/subsapp-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37a3f205')) {
      api.createRecord('37a3f205', component.options)
    } else {
      api.reload('37a3f205', component.options)
    }
    module.hot.accept("./my-profile.vue?vue&type=template&id=37a3f205&scoped=true", function () {
      api.rerender('37a3f205', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/my-profile/my-profile.vue"
export default component.exports